import { render, staticRenderFns } from "./ReferenceButton.vue?vue&type=template&id=b1e1054a&"
import script from "./ReferenceButton.vue?vue&type=script&lang=js&"
export * from "./ReferenceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports